module.exports = __webpack_public_path__ + "img/opinionlab-2013-establish.069afdef.jpg";